/* ============================================================================
   SUNNY STRIPES — BOOK NOW, AERATION & OVERSEEDING PAGE     added 2026-09-02
   ----------------------------------------------------------------------------
   THERE ARE NO PRICES AND NO VARIANT IDS IN THIS FILE. Prices come from
   ss-rates.js and the SKU->variant map from ss-variants.js, exactly as on the
   topdressing page and the instant quote.

   It reads the customer's choices out of the tool's own markup rather than its
   internals, for the same reason ss-book-topdressing.js does: aeration-quote.js
   keeps its state in a closure, and rewriting a working 38KB tool to expose it
   would be a bigger change than the button is worth.

     the selected size   #aolots .lot.sel[data-k]   -> s | m | l | xl | a1 | a3 | xx
     the services        #aosvcAe  core aeration          class "on" when ticked
                         #aosvcOs  overseeding
                         #aosvcDe  dethatching
                         #aosvcTd  compost topdressing
                         #aosvcTou next-season touch-up
                         #aosvcIr  temporary irrigation (only "on" with overseeding)
                         #aosvcHy  hydroseeding

   ----------------------------------------------------------------------------
   FOUR THINGS THIS PAGE DOES THAT THE TOPDRESSING PAGE DOES NOT

   1. AERATION AND OVERSEEDING TOGETHER ARE THEIR OWN SERVICE, not two.
      Ticking both switches the tool onto the `aerseed` curve, which is cheaper
      than `aerate` + `overseed` bought apart at every size - deliberately so,
      per the note in ss-rates.js. So the cart has to carry ONE aerseed line,
      never two, or the customer pays more than the page quoted.

   2. HYDROSEEDING HAS NO PRODUCT. It is quote-only: the price is the job, not
      a size band. If it is ticked, this offers no button at all rather than a
      basket that quietly leaves it out - somebody who ticked hydroseeding and
      checked out would reasonably believe they had bought it.

   3. THE PAIR DISCOUNT ONLY EXISTS AS A PRODUCT IN ONE SHAPE. Topdressing
      booked with a full aeration + overseed is sold as the already-discounted
      SS-TOPAER bundle, because a cart permalink cannot carry a discount. The
      tool, though, will discount topdressing against aeration ALONE or
      overseeding ALONE too, and there is no product for those pairs. Rather
      than overcharge by the discount, topdressing is held back in that case
      and the panel says so - the same thing ss-book-now.js does with
      fertilization when mowing is on.

   4. MEASURED AND CUSTOM SIZES DO NOT CART. Typing a square footage or tracing
      the lawn prices the real area off the marginal curve, which lands on
      numbers no product carries; 3+ acres is quoted per property. Both send
      the customer to the form with their number intact, rather than rounding
      them into a band that charges something else. See the longer note in
      ss-book-topdressing.js - the reasoning is identical.
   ============================================================================ */
(function () {
  "use strict";

  var PANEL_ID = "ssAoBook";

  function $(id) { return document.getElementById(id); }
  function on(id) {
    var el = $(id);
    return !!(el && / on(\s|$)/.test(" " + el.className));
  }
  function tierSelected() {
    var el = document.querySelector("#aolots .lot.sel[data-k]");
    return el ? el.getAttribute("data-k") : null;
  }
  function ready() {
    return window.SS_RATES && window.SS_VARIANTS && $("aoEstTotals");
  }
  function money(n) {
    return "$" + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  function tierArea(k) {
    var t = window.SS_RATES.tiers, i;
    for (i = 0; i < t.length; i++) if (t[i].k === k) return t[i].area;
    return null;
  }

  /* Mirrors build-products.js: round each service to $5, add, then round the
     discount and subtract. Discounting the raw sum instead is a $5 gap on a
     Large lawn. */
  function bundlePrice(area) {
    var SS = window.SS_RATES;
    var full = SS.round5(SS.price("topdress", area)) + SS.round5(SS.price("aerseed", area));
    return full - SS.round5(full * SS.bundleDiscount);
  }

  function build() {
    var SS = window.SS_RATES, V = window.SS_VARIANTS;

    if (on("aosvcHy")) return { quoteOnly: true };

    var tier = tierSelected();
    if (!tier || tier === "xx") return { measured: true };
    var area = tierArea(tier);
    if (area == null) return { measured: true };

    var aer = on("aosvcAe"), ovr = on("aosvcOs"), det = on("aosvcDe");
    var top = on("aosvcTd"), tou = on("aosvcTou"), irr = on("aosvcIr");

    var items = [], total = 0, held = null;
    var pair = aer && ovr;

    /* Topdressing rides with a FULL aeration + overseed as one discounted
       product. With only half of that, the tool discounts but the catalog has
       nothing to sell, so it comes out of the basket rather than being sold at
       a price the page did not quote. */
    var turfOnly = (aer || ovr) && !pair;
    if (top && turfOnly) { top = false; held = "topdressing"; }

    if (top && pair) {
      items.push({ svc: "topdressAeration", qty: 1 });
      total += bundlePrice(area);
    } else {
      if (pair) {
        items.push({ svc: "aerseed", qty: 1 });
        total += SS.round5(SS.price("aerseed", area));
      } else if (aer) {
        items.push({ svc: "aerate", qty: 1 });
        total += SS.round5(SS.price("aerate", area));
      } else if (ovr) {
        items.push({ svc: "overseed", qty: 1 });
        total += SS.round5(SS.price("overseed", area));
      }
      if (top) {
        items.push({ svc: "topdress", qty: 1 });
        total += SS.round5(SS.price("topdress", area));
      }
    }
    if (det) {
      items.push({ svc: "dethatch", qty: 1 });
      total += SS.round5(SS.price("dethatch", area));
    }
    if (tou) {
      items.push({ svc: "touchup", qty: 1 });
      total += SS.round5(SS.price("touchup", area));
    }
    /* Irrigation is never discounted, so it is always its own line. Above an
       acre it has no price and no product - quoted on site, like hydroseeding. */
    if (irr && ovr) {
      var irrPrice = SS.price("irrigation", area);
      if (irrPrice == null) return { irrigationQuote: true };
      items.push({ svc: "irrigation", qty: 1 });
      total += SS.round5(irrPrice);
    }

    if (!items.length) return { empty: true };

    /* An unknown SKU means the catalog is out of step with the rate card - a
       sync that has not run. Offer nothing rather than a partial basket. */
    var lines = [], i;
    for (i = 0; i < items.length; i++) {
      var sku = V.skuFor(items[i].svc, tier);
      if (!sku || !V.has(sku)) return { broken: true };
      lines.push({ sku: sku, qty: items[i].qty });
    }
    return {
      items: lines, total: total, count: lines.length,
      bundled: top && pair, held: held
    };
  }

  function styles() {
    if ($("ssAoBookCss")) return;
    var s = document.createElement("style");
    s.id = "ssAoBookCss";
    /* !important on the box metrics: this sits inside the tool's estimate rail,
       whose stylesheet zeroes padding and margin on the elements inside it. */
    var P = "#" + PANEL_ID;
    s.textContent =
      P + "{margin:18px 0 4px !important;padding:20px 18px 18px !important;" +
      "border:1.5px solid #E9EEDC;border-left:5px solid #A0C537;border-radius:13px;" +
      "background:#F6F4EC;font-family:'Assistant',Helvetica,Arial,sans-serif}" +
      P + " p{margin:0 !important;padding:0 !important}" +
      P + " .t{font-size:15.5px;font-weight:800;color:#235029;line-height:1.3;margin:0 0 7px !important}" +
      P + " .s{font-size:13px;line-height:1.55;color:#5F7060;margin:0 0 15px !important}" +
      P + " .s b{color:#235029}" +
      P + " .b{display:block;width:100%;border:none;border-radius:10px;margin:0 !important;" +
      "padding:14px 18px !important;background:#235029;color:#fff;font-family:inherit;" +
      "font-size:15px;font-weight:800;cursor:pointer;transition:background .15s}" +
      P + " .b:hover{background:#618500}" +
      P + " .b[disabled]{opacity:.55;cursor:default}" +
      P + " .d{border-top:1px solid #E4E0D2;font-size:12px;line-height:1.55;color:#6b7a70;" +
      "margin:15px 0 0 !important;padding:13px 0 0 !important}";
    document.head.appendChild(s);
  }

  function panel() {
    var el = $(PANEL_ID);
    if (el) return el;
    var anchor = $("aoEstTotals");
    if (!anchor || !anchor.parentNode) return null;
    el = document.createElement("div");
    el.id = PANEL_ID;
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
    return el;
  }

  var DISCLAIMER =
    '<p class="d">This price is based on the size band you picked. If the lawn ' +
    "turns out different once we're standing on it — a gate too narrow for the " +
    "machine, a steep slope, more planting bed than lawn — the price may change " +
    "slightly. We'll tell you before we start work, and we won't charge more " +
    "without your say-so. Wisconsin sales tax is added at checkout.</p>";

  function say(box, title, body) {
    box.style.display = "";
    box.innerHTML = '<p class="t">' + title + '</p><p class="s">' + body + "</p>";
  }

  function render() {
    if (!ready()) return;
    styles();
    var box = panel();
    if (!box) return;

    var q = build();

    if (q.broken || q.empty) { box.style.display = "none"; return; }

    if (q.quoteOnly) {
      return say(box, "We'll price this one properly",
        "Hydroseeding is quoted on the job rather than by lawn size — how bare the " +
        "ground is and how it drains change the number more than the square footage " +
        "does. Send the quote through and we'll come back with a fixed price.");
    }
    if (q.irrigationQuote) {
      return say(box, "We'll price the watering on site",
        "Temporary irrigation on a property this size depends on how many " +
        "spigots we can run from and how the lawn lies, so we price it after a " +
        "look. Send the quote through and we'll come back with a fixed price.");
    }
    if (q.measured) {
      return say(box, "We'll confirm this one with you",
        "You measured the lawn rather than picking a size band, so this price is " +
        "worked out from your actual square footage. Send it through and we'll " +
        "confirm it — or pick a size band above to book online right now.");
    }

    var url = window.SS_VARIANTS.cartUrl(q.items);
    if (!url) { box.style.display = "none"; return; }

    var held = q.held
      ? " Compost topdressing isn't in this basket: booked with a full aeration " +
        "and overseed it comes as a discounted pair, and on its own alongside " +
        "half of that we'd rather quote it than charge you the undiscounted price. " +
        "Send the quote and we'll sort it."
      : "";

    box.style.display = "";
    box.innerHTML =
      '<p class="t">Ready to book it?</p>' +
      '<p class="s">Take ' + (q.count === 1 ? "this service" : "these " + q.count + " services") +
      " to checkout — <b>" + money(q.total) + "</b>" +
      (q.bundled ? " (topdressing bundled in at " +
        Math.round(window.SS_RATES.bundleDiscount * 100) + "% off)" : "") +
      ". Or send the quote and we'll follow up." + held + "</p>" +
      '<button type="button" class="b" id="ssAoBookGo">Book now &rarr;</button>' +
      DISCLAIMER;

    var btn = $("ssAoBookGo");
    if (btn) {
      btn.setAttribute("data-cart", url);
      btn.addEventListener("click", function () {
        btn.disabled = true;
        btn.textContent = "Opening your cart…";
        window.location.href = url;
      });
    }
  }

  /* The tool redraws its estimate rail on every change, so watching the rail is
     the hook - it catches size changes, service toggles and mode switches alike
     without knowing anything about the tool's internals. Clicks are watched too
     because the size cards sit outside the rail and a change can leave the rail
     text identical. */
  function watch() {
    var rail = $("aoEstItems") || $("aoEstTotals");
    if (!rail) return false;
    var pending = null;
    var soon = function (ms) {
      clearTimeout(pending);
      pending = setTimeout(function () { try { render(); } catch (e) {} }, ms);
    };
    new MutationObserver(function () { soon(40); })
      .observe(rail, { childList: true, subtree: true, characterData: true });
    document.addEventListener("click", function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest("#aotool")) soon(60);
    });
    /* Back button / bfcache restore: the button would come back disabled and
       still reading "Opening your cart…". */
    window.addEventListener("pageshow", function () { try { render(); } catch (e) {} });
    return true;
  }

  var tries = 0;
  var t = setInterval(function () {
    if (ready() && watch()) {
      clearInterval(t);
      try { render(); } catch (e) {}
      return;
    }
    if (++tries > 80) {
      clearInterval(t);
      if (!window.SS_VARIANTS) {
        console.warn("Sunny Stripes: ss-variants.js did not load; aeration Book Now is off.");
      }
    }
  }, 50);
})();
